import React from 'react';
import { Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import UnitsEnum from '@/constants/unitsEnum';
import { useMeasurement } from '@/hooks/useMeasurement';
import Super from '@/comp/Super';
import { useValueByConnectivity } from '@/hooks/useValueByConnectivity';

const SensorValue = observer(({ metric, unit, entity, connectivity }) => {
  const { tunit, tvalue } = useMeasurement();
  const { tcunit, tcvalue } = useValueByConnectivity();

  return (
    <div className="value-container">
      <span className="value">{tcvalue(tvalue(entity[metric], unit), connectivity)}</span>
      <span className="label">
        {unit === UnitsEnum.m3Min ? (
          <Trans i18nKey={tcunit(tunit(unit), entity[metric], connectivity)}>
            <Super />
          </Trans>
        ) : (
          tcunit(tunit(unit), entity[metric], connectivity)
        )}
      </span>
    </div>
  );
});

export default SensorValue;
